<!-- <p>select-organization-dialog works!</p> -->
<h2 mat-dialog-title>Select Organization</h2>

<mat-dialog-content>
  <mat-spinner *ngIf="organizations.length == 0"></mat-spinner>
  <mat-form-field
    *ngIf="organizations.length != 0"
    appearance="outline"
    class="w-full"
    style="margin-top: 10px"
  >
    <mat-label>Organization</mat-label>
    <input
      matInput
      type="text"
      [matAutocomplete]="auto"
      [formControl]="orgControl"
      [placeholder]="'Search organization'"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn"
      (optionSelected)="onOrgSelected($event.option.value)"
    >
      <mat-option
        *ngFor="let org of filteredOrganizations | async"
        [value]="org"
      >
        {{ org.organizationName }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="!selectedOrg"
    (click)="login()"
  >
    Login
  </button>
</mat-dialog-actions>
